export default {
	title: 'Escenarios',
	subtitle: 'Lista todos los escenarios posibles que evaluarás',
	no_description: 'Sin escenario',

	context_worse: 'Negativo',
	context_best: 'Positivo',

	tabs: {
		list: 'Lista',
		details: 'Detalles',
		visualization: 'Visualización',
		alt_title: 'Síntesis'
	}
};
